import api from '@services/interceptor';
import { useWorkspaceStore } from '@stores/WorkspaceData';
class SatService {
  constructor(){
    this.wp = undefined
  }
  async GetSat(allowCreate = true){
    if(!this.wp)this.wp = await useWorkspaceStore()
    try {
      const response = await api.get(`/api/sat/${this.wp.wpid}`);
      if ((!response.data || !response.data.length) && allowCreate){
        // КА ещё нет — создаём один по умолчанию, повторно не пытаемся
        await this.CreateSat()
        return await this.GetSat(false)
      }
      return response.data;
    } catch (error) {
      console.log(error)
    }
    return null
  }
  async PutSat(data){
    try {
      const response = await api.put(`/api/sat/${this.wp.wpid}/${data.id}`, data);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }
  async CreateSat(){
    try {
      const response = await api.post(`/api/sat/${this.wp.wpid}`, this.  GetSatDefault());
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }
  GetSatDefault(){
        return {
          "name": "newSat",
          "config": {
            "mass": 0,
            "inertiaTensor": [
              [0,0,0],[0,0,0],[0,0,0]
            ],
            "orbit": {
              "semiMajorAxis": 0,
              "eccentricity": 0,
              "inclination": 0,
              "raan": 0,
              "argPerigee": 0,
              "trueAnomaly": 0
            },
            "imagingSensor": {
              "type": "OES",
              "maxAllowedShootingAngle": 0,
              "fieldOfView": 0,
              "shootingAngleRangeMin": 0,
              "shootingAngleRangeMax": 0,
              "afarBeamControlRoll": 0,
              "afarBeamControlPitch": 0
            },
            "agile": {
              "acceleration": 0,
              "speed": 0,
              "stabilizationTime": 0
            },
            "reactionWheels": [
              {
                "id": "string_value",
                "maxTorque": 0,
                "maxAngularMomentum": 0,
                "axisX": 0,
                "axisY": 0,
                "axisZ": 0
              }
            ],
            "starSensors": [
              {
                "id": "string_value",
                "orientationX": 0,
                "orientationY": 0,
                "orientationZ": 0,
                "angleErrorX": 0,
                "angleErrorY": 0,
                "angleErrorZ": 0,
                "measurementCycle": 0
              }
            ],
            "angularRateSensors": [
              {
                "id": "string_value",
                "orientationX": 0,
                "orientationY": 0,
                "orientationZ": 0,
                "scaleFactor": 0,
                "randomWalk": 0,
                "biasStability": 0,
                "biasInterval": 0,
                "noise": 0,
                "measurementCycle": 0
              }
            ]
          }
        }
    }

}

export const satService = new SatService();